import { render } from "./ServiceDetailPage.vue?vue&type=template&id=7afd2d70"
import script from "./ServiceDetailPage.vue?vue&type=script&lang=js"
export * from "./ServiceDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__